import axios from 'axios';
import getConfig from 'next/config';

/**
 * @async
 * @param {string} query
 * @param {string} language
 * @param {string} [filterByCountry='']
 * @returns {Promise<any>}
 */
const fetchGeoapifyAutocomplete = async (
  query,
  language,
  filterByCountry = '',
) => {
  const { publicRuntimeConfig } = getConfig();
  const { clientId, apiBasePath } = publicRuntimeConfig;
  const queryFilterByCountry =
    filterByCountry && `&filter=countrycode:${filterByCountry}`;
  const lang = language && language.split('-')[0];
  const url = `${apiBasePath}/geo-autocomplete?text=${encodeURIComponent(
    query,
  )}&limit=5&lang=${lang}${
    clientId === 'fse' ? '&filter=countrycode:de' : queryFilterByCountry
  }`;
  const headers = {
    'Content-Type': 'application/json',
  };
  try {
    const response = await axios.get(url, { headers });
    return response.data.features;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

/**
 * @param {*} feature
 * @returns {LocationSuggestion}
 */
const transformGeoapifyRes = (feature) => {
  const coords = {
    lat: feature.geometry.coordinates[1],
    lng: feature.geometry.coordinates[0],
  };
  return {
    name: feature.properties.formatted,
    shortName: feature.properties.formatted,
    coords,
    active: false,
    bbox: feature.bbox,
    resultType: feature.properties.result_type,
    geoapifyData: { ...feature },
  };
};

/**
 * @async
 * @param {string} searchString
 * @param {?string} [lang]
 * @param {?string} [filterByCountry]
 * @returns {Promise<LocationSuggestion[]>}
 */
const fetchGeoapifySuggestions = async (
  searchString,
  lang,
  filterByCountry,
) => {
  const { publicRuntimeConfig } = getConfig();
  const language = lang || publicRuntimeConfig.defaultLanguage;

  try {
    const resData = await fetchGeoapifyAutocomplete(
      searchString,
      language,
      filterByCountry,
    );
    const result =
      resData && resData.map((feature) => transformGeoapifyRes(feature));
    return result;
  } catch (error) {
    return [];
  }
};

export default fetchGeoapifySuggestions;
